import { render, staticRenderFns } from "./DatePickerComponent.vue?vue&type=template&id=38f50fbc"
import script from "./DatePickerComponent.vue?vue&type=script&lang=ts"
export * from "./DatePickerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports